/* eslint-disable @typescript-eslint/no-namespace */
import { Box, Typography, Grid, Link, Stack } from '@mui/material';
import { useEffect } from 'react';
// import ReactPlayer from 'react-player';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'media-controller': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      'media-control-bar': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      'media-play-button': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      'media-mute-button': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      'media-volume-range': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      'media-time-range': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      'media-pip-button': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
      'media-fullscreen-button': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

const MuxMediaChromePlayer = () => {
  return (
    <div
      style={{
        maxWidth: '720px',
        width: '100%',
        margin: '0 auto',
      }}>
      <media-controller
        style={{
          borderRadius: '1.6rem',
          overflow: 'clip',
        }}>
        <video
          slot="media"
          src="https://cd-clients.s3.eu-north-1.amazonaws.com/tprx/Thank+You+Medicare.mp4"
          crossOrigin=""
          poster="https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/65a178680aec707426e16d7d_653a79c23c3d9992e23a0e15_bg.webp"
          style={{ width: '100%' }}></video>
        <media-control-bar>
          <media-play-button />
          <media-mute-button />
          <media-volume-range />
          <media-time-range />
          <media-fullscreen-button />
        </media-control-bar>
      </media-controller>
    </div>
  );
};

const ThankYouFym = () => {
  useEffect(() => {
    const progressBar = document.getElementById('scroll-progress-bar');

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = window.scrollY;
          const docHeight =
            document.documentElement.scrollHeight - window.innerHeight;
          const scrollProgress = (scrollTop / docHeight) * 100;
          if (progressBar) {
            progressBar.style.height = `${scrollProgress}%`;
          }
          ticking = false;
        });
        ticking = true;
      }
    };
    window.innerWidth > 768 && window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <svg
        style={{
          width: '100%',
          height: 'auto',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 0,
          pointerEvents: 'none',
        }}
        viewBox="0 0 1920 718"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect
          opacity="0.35"
          x="1920"
          y="6.10352e-05"
          width="717.322"
          height="1920"
          transform="rotate(90 1920 6.10352e-05)"
          fill="url(#paint0_radial_217_1952)"></rect>
        <defs>
          <radialGradient
            id="paint0_radial_217_1952"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1525.1 0.000212018) rotate(12.1664) scale(1137.78 1979.26)">
            <stop stopColor="#076890"></stop>
            <stop offset="0.702753" stopColor="#89AEB7"></stop>
            <stop offset="0.964772" stopColor="#89AEB7" stopOpacity="0"></stop>
          </radialGradient>
        </defs>
      </svg>

      <Box sx={{ position: 'relative' }}>
        {/* Hero Section */}
        <Stack
          py={6}
          direction={'column'}
          width={'81rem'}
          maxWidth={0.95}
          alignItems={'center'}
          mx={'auto'}
          gap={2}>
          <Typography
            variant="h1"
            align="center"
            sx={{
              fontSize: { xs: '3.2rem', md: '4.8rem' },
              color: '#153b61',
            }}>
            Thank you for your payment. Welcome to TransparentpriceRX
          </Typography>
          <Typography
            variant="h2"
            gutterBottom
            align="center"
            sx={{
              fontWeight: 400,
              fontSize: { xs: '2.4rem', md: '3.2rem' },
            }}>
            Your Seamless Path to Convenient Medication Delivery
          </Typography>
          <Typography
            variant="body1"
            paragraph
            align="center"
            width={'51rem'}
            maxWidth={0.95}
            sx={{
              fontSize: { xs: '1.6rem', md: '1.8rem' },
            }}>
            We are thrilled to have you onboard.
            <br />
            Your journey to a hassle-free, convenient, and transparent
            medication procurement experience starts here.
          </Typography>
          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
            <MuxMediaChromePlayer />
          </Box>
        </Stack>

        {/* What’s Next Section */}
        <Stack gap={4} width={'53rem'} maxWidth={0.95} mx={'auto'} mt={8}>
          <Typography
            variant="h2"
            align="center"
            gutterBottom
            sx={{
              fontSize: { xs: '2.4rem', md: '3.2rem' },
            }}
            color={'#153b61'}>
            What’s Next?
          </Typography>
          <Stack
            direction={'row'}
            justifyContent={'center'}
            gap={4}
            alignItems={'stretch'}>
            <Stack
              sx={{
                display: { xs: 'none', md: 'block' },
              }}
              width={4}
              alignItems={'center'}
              position={'relative'}
              flex={0}>
              <Box
                bgcolor={'#89aeb7'}
                width={'2px'}
                height={'100%'}
                mx={'auto'}
              />
              <Box
                id="scroll-progress-bar"
                bgcolor="#153b61"
                borderRadius={100}
                position="absolute"
                width="4px"
                mx="auto"
                sx={{
                  top: 0,
                  height: '0%',
                  transition: 'height 0.2s ease',
                }}
              />
            </Stack>
            <Stack spacing={4} alignSelf={'stretch'} flex={1}>
              {[
                [
                  '01/05',
                  'Welcome Call',
                  'Within 48 hours (2 Business days) of your enrollment, we will schedule a welcome call to guide you through the process, set expectations, and ensure you feel confident about your next steps. This call will help clarify any questions and give you peace of mind that everything is on track.',
                  'https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/67bdbcc4c1f501b126e30852_phoneIcon.svg',
                ],
                [
                  '02/05',
                  'Welcome Email',
                  "You will receive your  TransparentpriceRX welcome email within 72 Hours (three business days) Email. We've aligned ourselves with a U.S.-based nonprofit pharmacy to ensure a smooth enrollment for you.",
                  'https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/651129d190b712e0108964b6_Welcome%20Email.svg',
                ],
                [
                  '03/05',
                  'Healthcare Provider Communication',
                  'You and your health care provider will receive timely reminders to ensure an uninterrupted supply of medications all year round.',
                  'https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/651129d1cf6103bc77401909_Health%20Communication.svg',
                ],
                [
                  '04/05',
                  'Medication Review',
                  "Your health care provider will review, approve, and sign all medication forms before sending them to the manufacturer's pharmacy.",
                  'https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/651129d0a440e1caefc8f2a8_Medication%20Review.svg',
                ],
                [
                  '05/05',
                  'Year-Round Service',
                  'Expect timely refill reminders for you and your health care provider through our specialized software.',
                  'https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/651129d1bdc044295dd4fc3e_YearService.svg',
                ],
              ].map(([step, title, desc, icon], i) => (
                <Stack
                  key={i}
                  bgcolor={'#ffffffbf'}
                  border={1}
                  borderColor={'#e3e3e3'}
                  borderRadius={4}
                  p={4}
                  sx={{
                    boxShadow: '0 10px 15px #0000000d',
                    backdropFilter: 'blur(10px)',
                  }}>
                  <Stack
                    direction={'row'}
                    gap={2}
                    width={'100%'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    mb={2}>
                    <Box
                      component="img"
                      src={`${icon}`}
                      alt={title}
                      sx={{ width: 48, height: 48 }}
                    />
                    <Typography variant="body2" fontWeight={700}>
                      {step}
                    </Typography>
                  </Stack>
                  <Typography variant="h3" mb={2}>
                    {title}
                  </Typography>
                  <Typography variant="body1">{desc}</Typography>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Stack>

        {/* Membership Benefits */}
        <Stack mt={8} spacing={4} alignItems={'center'}>
          <Typography
            variant="h2"
            align="center"
            gutterBottom
            sx={{
              fontSize: { xs: '2.4rem', md: '3.2rem' },
            }}
            color={'#153b61'}>
            TransparentpriceRX Membership Benefits
          </Typography>
          <Grid
            container
            spacing={2}
            width={'97.2rem'}
            maxWidth={0.95}
            mx={'auto'}
            sx={{
              '& > .MuiGrid-item': { paddingLeft: { xs: 0, sm: 0, md: 2 } },
            }}>
            {[
              [
                'Comprehensive Pharmacy Access',
                'Secure connections with a wide range of medication for streamlined fulfillment',
                'https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/651129d1562f3cba173dd303_Pharmacy%20Access.svg',
              ],
              [
                'Direct Communication',
                'Our advanced software enables seamless dialogue between you, your healthcare provider, and pharmaceutical manufacturers.',
                'https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/651129d0344b427fd44b2057_Direct%20Communication.svg',
              ],
              [
                'Refill Reminders',
                'You and your health care provider will receive timely reminders to ensure an uninterrupted supply of medications all year round.',
                'https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/651129d1c370dd7b59fa5d61_RefiilReminder.svg',
              ],
              [
                'Convenient Delivery',
                'Your medications will be delivered to your door step in a 90-day supply, saving you from frequent pharmacy visits.',
                'https://cdn.prod.website-files.com/64c1145cbf2b6e07020d3b41/651129d1562f3cba173dd329_Delivery.svg',
              ],
            ].map(([title, desc, icon], i) => (
              <Grid item xs={12} md={6} key={i}>
                <Stack
                  height={'100%'}
                  key={i}
                  bgcolor={'#ffffffbf'}
                  border={1}
                  borderColor={'#e3e3e3'}
                  borderRadius={4}
                  p={4}
                  sx={{
                    boxShadow: '0 10px 15px #0000000d',
                    backdropFilter: 'blur(10px)',
                  }}>
                  <Box
                    component="img"
                    src={`${icon}`}
                    alt={title}
                    sx={{ width: 48, height: 48 }}
                    mb={2}
                  />
                  <Typography variant="h3" mb={2}>
                    {title}
                  </Typography>
                  <Typography variant="body1">{desc}</Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Stack>
        {/* Real Time */}
        <Stack
          mt={8}
          spacing={4}
          alignItems={'center'}
          bgcolor={'#076890'}
          py={8}>
          <Typography
            variant="h2"
            align="center"
            width={'90rem'}
            maxWidth={0.95}
            sx={{ fontSize: { xs: '2.4rem', md: '3.2rem' }, color: '#fff' }}>
            The welcome email you'll receive is generated in real time.<br></br>{' '}
            ‍<br />
            We have already initiated the processing of your requested
            medication.
          </Typography>
        </Stack>
        {/* Contact Section */}
        <Stack mt={8} spacing={2} alignItems={'center'} py={8}>
          <Typography
            variant="h2"
            align="center"
            sx={{
              fontSize: { xs: '2.4rem', md: '4.8rem' },
            }}>
            Contact Us
          </Typography>
          <Typography
            align="center"
            variant="h3"
            sx={{
              fontSize: { xs: '1.6rem', md: '2.4rem' },
            }}>
            We look forward to serving you with excellence and efficiency.
          </Typography>
          <Typography align="center" sx={{ mt: 2 }}>
            <Link
              fontWeight={700}
              sx={{
                fontSize: { xs: '1.6rem', md: '2.4rem' },
              }}
              href="mailto:customerservice@transparentpricerx.com">
              customerservice@transparentpricerx.com
            </Link>
          </Typography>
          <Typography align="center">
            Check your spam folder to ensure you receive all our communications.
          </Typography>
        </Stack>
      </Box>
    </>
  );
};

export default ThankYouFym;
